declare const process: any;

export const environment = {
  production: false,
  apiUrl: 'https://api-new-acc.autotaxatiepartners.nl',
  application: 'atp-monitoring',
  password: '4AFbPkPLCUu3smE3rGBI',
  level: ['person'],
  version: '2.0.0',
  elasticIndexName: 'valuation-prod-1.8',
};